<template>
<div class="chapter">
<div class="inner_page">
<div><a id="cr"></a></div>
<p class="copyright1">Copyright © 2013 by Ken Francis</p>
<p class="copyright2">All rights reserved.</p>
<p class="copyright2">ISBN 9781625171023<br/>
Just Write/5150 Media Publishing<br/>
19202 Moorshine Place</p>
<p class="copyright3">Cerritos, CA 90703</p>
<p class="copyright2"><a href="http://www.justwritepublishing.com" target="_blank">www.justwritepublishing.com</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 38_cr.vue?2d2b04c0